import styled from "styled-components"

const LogoNumberStyled = styled.div`
  padding-top: 70px;
  @media (max-width: 880px) {
    padding-top: 40px;
  }
  .logoNumber__wrapper {
    display: flex;
    justify-content: space-between;
    padding-bottom: 70px;
    padding-top: 40px;
    max-width: 1020px;
    margin: 0 auto;
    @media (max-width: 880px) {
      flex-wrap: wrap;
      padding-bottom: 40px;
      padding-top: 0px;
      margin-top: -30px;
    }
    &__logo {
      width: calc(66.66% - 10px);
      padding: 40px 40px 75px;
      box-shadow: 0 0 20px rgba(230, 161, 172, 0.2);
      text-align: center;
      @media (max-width: 1080px) {
        img {
          max-width: 100%;
          height: auto;
        }
      }
      @media (max-width: 880px) {
        width: 100%;
        margin-bottom: 00px;
        box-shadow: none;
        padding: 0px 0 0px;
      }
    }
    &__number {
      width: calc(33.33% - 10px);
      padding: 40px 40px 75px;
      box-shadow: 0 0 20px rgba(230, 161, 172, 0.2);
      text-align: center;
      @media (max-width: 880px) {
        width: 100%;
        padding: 40px 0 35px;
        box-shadow: none;
        margin-top: -10px;
      }
    }
  }
  .logoNumber__number {
    font-size: 74px;
    line-height: 1.1;
    font-weight: 500;
    margin: -10px 0 0;
  }
  .logoNumber__textAfterNumber {
    margin: 0;
    font-size: 16px;
  }
`

export default LogoNumberStyled
